// src/lib/state/health.state.svelte.ts
// Migrated from src/lib/stores/healthStore.ts to Svelte 5 runes
import { SvelteDate } from 'svelte/reactivity';
import type { HealthResponse } from '$lib/types/api/responses.types';

// Health store state interface
export interface HealthStoreState {
	healthStatus: HealthResponse | null;
	isDevelopment: boolean;
	isProduction: boolean;
	isHealthy: boolean;
	microsoftSsoEnabled: boolean;
	authEnabled: boolean;
	lastError: Error | null;
	lastChecked: Date | null;
}

// Initial state
const initialState: HealthStoreState = {
	healthStatus: null,
	isDevelopment: false,
	isProduction: false,
	isHealthy: false,
	microsoftSsoEnabled: false,
	authEnabled: true,
	lastError: null,
	lastChecked: null
};

// CORRECTED PATTERN: Wrap state in object to avoid direct reassignment issue
// Per Svelte 5 docs: "you can't directly export reassignable $state"
// Solution: Wrap in object and mutate properties instead of reassigning
export const healthState = $state<HealthStoreState>({ ...initialState });

// Mutator functions
export function reset(): void {
	Object.assign(healthState, initialState);
}

export function setHealthStatus(status: HealthResponse): void {
	healthState.healthStatus = status;
	healthState.lastChecked = new SvelteDate();
}

export function setEnvironmentInfo(
	isHealthy: boolean,
	isDevelopment: boolean,
	microsoftSsoEnabled: boolean = false,
	authEnabled: boolean = true
): void {
	healthState.isHealthy = isHealthy;
	healthState.isDevelopment = isDevelopment;
	healthState.isProduction = !isDevelopment;
	healthState.microsoftSsoEnabled = microsoftSsoEnabled;
	healthState.authEnabled = authEnabled;
	healthState.lastChecked = new SvelteDate();
}

export function setError(error: Error): void {
	healthState.lastError = error;
	healthState.lastChecked = new SvelteDate();
}

// Snapshot helper for reading current state
export function getSnapshot(): HealthStoreState {
	return {
		healthStatus: healthState.healthStatus,
		isDevelopment: healthState.isDevelopment,
		isProduction: healthState.isProduction,
		isHealthy: healthState.isHealthy,
		microsoftSsoEnabled: healthState.microsoftSsoEnabled,
		authEnabled: healthState.authEnabled,
		lastError: healthState.lastError,
		lastChecked: healthState.lastChecked
	};
}
